import React from "react";
import { motion } from "framer-motion";

/**
 * Slow editorial marquee. Two duplicate tracks scroll continuously.
 * items: array of strings
 */
export default function Marquee({ items, speed = 60, className = "" }) {
  const doubled = [...items, ...items, ...items, ...items];
  return (
    <div className={`abc-marquee ${className}`} aria-hidden="true">
      <motion.div
        className="abc-marquee-track"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ duration: speed, ease: "linear", repeat: Infinity }}
      >
        {doubled.map((label, i) => (
          <span key={i} className="abc-marquee-item">
            <span className="abc-marquee-word">{label}</span>
            <span className="abc-marquee-star" aria-hidden="true">✱</span>
          </span>
        ))}
      </motion.div>
    </div>
  );
}
